import React, { createContext, useContext } from "react";
import { Constants } from "utils";

interface ProvidedValueType {
  t: any;
  locale: string;
  locales: any;
  setLocale: (language: string) => void;
}

const initialState = {
  locale: "EN",
  translations: Constants.LOCALE_STRINGS[Constants.REGIONS.EN],
  locales: Object.keys(Constants.REGIONS),
};

export const LocaleContext = createContext<ProvidedValueType>({
  t: initialState.translations,
  locale: initialState.locale,
  locales: initialState.locales,
  setLocale: () => {},
});

interface Props {
  initial: string;
  children?: React.ReactNode;
}

export const LocaleProvider = React.memo<Props>(({ initial, children }) => {
  const [locale, setLocale] = React.useState<string>(initial);

  const setLocaleCallback = React.useCallback((newLocale: string) => {
    setLocale((currentLocale: string) =>
      currentLocale === newLocale ? currentLocale : newLocale
    );
  }, []);

  const MemoizedValue = React.useMemo(() => {
    const value: ProvidedValueType = {
      locale,
      t: Constants.LOCALE_STRINGS[locale],
      locales: Constants.LOCALE_STRINGS[locale],
      setLocale: setLocaleCallback,
    };
    return value;
  }, [locale, setLocaleCallback]);

  return (
    <LocaleContext.Provider value={MemoizedValue}>
      {children}
    </LocaleContext.Provider>
  );
});

export const useLocale = () => useContext(LocaleContext);
